import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { A6TransactionsEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";

const client = "a6";
const table_name = "a6_transactions";

export const A6TransactionsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <A6TransactionsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={table_name}
          client={client}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
